export default __webpack_public_path__ + "static/media/Deutsches-Taubblindenwerk-Logo-klein.99831054.png";